/**
 * src/reporting/ReporterInstaller.tsx
 *
 * Mounts once inside the authenticated tree to wire current user context +
 * the Harper WS log getter into the module-level error/feedback reporter.
 * Renders nothing.
 */

import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useCustomerProfile } from '../hooks/useCustomerProfile';
import { useHarperWsLog } from '../context/HarperWSContext';
import { installReporter } from './reporter';

export function ReporterInstaller() {
  const { customerEmail } = useAuth();
  const { profile } = useCustomerProfile();
  const getWsLog = useHarperWsLog();

  useEffect(() => {
    installReporter({
      getUser: () => ({
        customer_id: profile?.id ?? null,
        customer_email: customerEmail ?? profile?.email ?? null,
        role: profile?.role ?? null,
      }),
      getWsLog,
    });
  }, [customerEmail, profile?.id, profile?.email, profile?.role, getWsLog]);

  return null;
}
